import React, { useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useNavigate } from 'react-router';
import { Box } from '@mui/system';
import WebAppointmentBookingLink from './WebAppointmentBookingLink/WebAppointmentBookingLink';
import GstBillsPage from './GstBillsData/GstBillsPage';
import { Button, Snackbar, Alert } from '@mui/material';

const Settings = () => {
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [notification, setNotification] = useState('');
  const [showGstBills, setShowGstBills] = useState(false);
   
  const {
    fetchAOwner,
    setOwnerData,
    ownerData,
    setActiveBranchId,
    getBranch,
    setBranchData,
    setParantBranchData,
    activeBranchId,
    updateGeoLocation,
    setShowMessage,
    branchData
  } = useMain();

  console.log(activeBranchId);
   console.log(branchData,'branchdataaaaa')
  const fetchLocation = async () => {
    if (navigator.geolocation) {
      console.log(navigator.geolocation);
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
          if (latitude || longitude) {
            const res = await updateGeoLocation(activeBranchId, JSON.stringify({ location: { latitude, longitude } }));
            if (res) {
              setShowMessage("Location update done.");
              setNotification('Location updated successfully');
            }
          }
          console.log(latitude, longitude);
        },
        (error) => {
          setError(error.message);
          console.error('Error fetching location:', error);
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
      );
    } else {
      setError('Geolocation is not supported by this browser.');
      console.error('Geolocation is not supported by this browser.');
    }
  };

  const refreshBranchData = async (id) => {
    try {
      const res = await getBranch(id);
      if (res.statusCode === 200) setBranchData((pre) => ({ ...pre, ...res.data }));
    } catch (error) {
      console.error('Error refreshing branch data:', error);
    }
  };

  const refreshData = async (id) => {
    try {
      setLoading(true);
      const res = await fetchAOwner(id);
      if (res?.statusCode === 200) {
        const owner = res?.data;
        if (owner?.activeStatus && owner?.activeStatus.toLowerCase() !== 'active') {
          localStorage.removeItem('salon-admin');
          setActiveBranchId(null);
          setBranchData({});
          setOwnerData({});
          navigate('/auth/login');
          return;
        }
        refreshBranchData(owner?.branch[0]?._id);
        localStorage.setItem('salon-admin', JSON.stringify(owner._id));
        setOwnerData(owner);
        setParantBranchData(
          () => owner?.branch?.filter((item) => item?.activeStatus === 'APPROVED')[0],
        );
        setActiveBranchId(
          () => owner?.branch?.filter((item) => item?.activeStatus === 'APPROVED')[0]?._id,
        );
      }
    } catch (error) {
      console.error('Error refreshing data:', error);
    } finally {
      setLoading(false);
    }
  };
  console.log(ownerData,'ownerData')
  return (
    <PageContainer title="Settings" description="This is the settings page">
      <DashboardCard2 title="Settings">
        {loading ? (
          <ShowLoader />
        ) : (
          <Box display='flex' flexDirection='column' gap={'10px'} justifyContent={"start"}>
            <WebAppointmentBookingLink />
            {/* <div className="gstbill-btn">
              <Button onClick={fetchLocation} variant='contained'>
                Update Location
              </Button>
            </div> */}
            {/* <GstBillsPage /> */}
            {/* <Button style={{width:"10%",padding:"0.3rem 0.1rem"}}
            variant="contained" onClick={()=> setShowGstBills(!showGstBills)}>
              {showGstBills ? 'Hide GST Bills' : 'Show GST Bills'}
            </Button>
            {showGstBills && <GstBillsPage/>} */}
          </Box>
        )}
      </DashboardCard2>
      <Snackbar
        open={!!notification}
        autoHideDuration={6000}
        onClose={() => setNotification('')}
      >
        <Alert onClose={() => setNotification('')} severity="success" sx={{ width: '100%',marginLeft:'20rem' }}>
          {notification}
        </Alert>
      </Snackbar>
    </PageContainer>
  );
};

export default Settings;

// import React, { useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { useNavigate } from 'react-router';
// import { Box, Button, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid } from '@mui/material';
// import WebAppointmentBookingLink from './WebAppointmentBookingLink/WebAppointmentBookingLink';
// import GstBillsPage from './GstBillsData/GstBillsPage';
// import Template1Image from '../../../assets/Template-images/template1.png';
// import Template2Image from '../../../assets/Template-images/template2.png';
// import Template3Image from '../../../assets/Template-images/template3.png';

// const templates = [
//   { id: 1, name: 'Template for A4 Size Printer', image: Template2Image },
//   { id: 2, name: 'Modern template with Review', image: Template3Image },
//   { id: 3, name: 'Minimal Template For Thermal Printer', image: Template1Image },
// ];

// const Settings = () => {
//   const navigate = useNavigate();
  
//   const [loading, setLoading] = useState(false);
//   const [location, setLocation] = useState(null);
//   const [error, setError] = useState(null);
//   const [notification, setNotification] = useState('');
//   const [showGstBills, setShowGstBills] = useState(false);
//   const [openTemplateDialog, setOpenTemplateDialog] = useState(false);
//   const [selectedTemplate, setSelectedTemplate] = useState(1);
   
//   const {
//     fetchAOwner,
//     setOwnerData,
//     ownerData,
//     setActiveBranchId,
//     getBranch,
//     setBranchData,
//     setParantBranchData,
//     activeBranchId,
//     updateGeoLocation,
//     setShowMessage,
//     branchData,
//     updateOwnerProfile
//   } = useMain();

//   const handleTemplateSelect = (templateId) => {
//     setSelectedTemplate(templateId);
//   };

//   const handleUpdateTemplate = async () => {
//     setLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append('selectedBillTemplate', selectedTemplate);

//       const res = await updateOwnerProfile(ownerData._id, formData);
//       if (res.statusCode === 200) {
//         setShowMessage({
//           message: 'Bill template updated successfully',
//           messageType: 'success',
//         });
//         setNotification('Bill template updated successfully');
//         refreshData(ownerData._id);
//         setOpenTemplateDialog(false);
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Update failed',
//         messageType: 'error',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const fetchLocation = async () => {
//   //   if (navigator.geolocation) {
//   //     navigator.geolocation.getCurrentPosition(
//   //       async (position) => {
//   //         const { latitude, longitude } = position.coords;
//   //         setLocation({ latitude, longitude });
//   //         if (latitude || longitude) {
//   //           const res = await updateGeoLocation(activeBranchId, JSON.stringify({ location: { latitude, longitude } }));
//   //           if (res) {
//   //             setShowMessage("Location update done.");
//   //             setNotification('Location updated successfully');
//   //           }
//   //         }
//   //       },
//   //       (error) => {
//   //         setError(error.message);
//   //         console.error('Error fetching location:', error);
//   //       },
//   //       { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
//   //     );
//   //   } else {
//   //     setError('Geolocation is not supported by this browser.');
//   //   }
//   // };

//   const refreshBranchData = async (id) => {
//     try {
//       const res = await getBranch(id);
//       if (res.statusCode === 200) setBranchData((pre) => ({ ...pre, ...res.data }));
//     } catch (error) {
//       console.error('Error refreshing branch data:', error);
//     }
//   };

//   const refreshData = async (id) => {
//     try {
//       setLoading(true);
//       const res = await fetchAOwner(id);
//       if (res?.statusCode === 200) {
//         const owner = res?.data;
//         if (owner?.activeStatus && owner?.activeStatus.toLowerCase() !== 'active') {
//           localStorage.removeItem('salon-admin');
//           setActiveBranchId(null);
//           setBranchData({});
//           setOwnerData({});
//           navigate('/auth/login');
//           return;
//         }
//         refreshBranchData(owner?.branch[0]?._id);
//         localStorage.setItem('salon-admin', JSON.stringify(owner._id));
//         setOwnerData(owner);
//         setParantBranchData(
//           () => owner?.branch?.filter((item) => item?.activeStatus === 'APPROVED')[0],
//         );
//         setActiveBranchId(
//           () => owner?.branch?.filter((item) => item?.activeStatus === 'APPROVED')[0]?._id,
//         );
//         // Set the selected template from owner data
//         if (owner.selectedBillTemplate) {
//           setSelectedTemplate(owner.selectedBillTemplate);
//         }
//       }
//     } catch (error) {
//       console.error('Error refreshing data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <PageContainer title="Settings" description="This is the settings page">
//       <DashboardCard2 title="Settings">
//         {loading ? (
//           <ShowLoader />
//         ) : (
//           <Box display='flex' flexDirection='column' gap={'10px'} justifyContent={"start"}>
//             <WebAppointmentBookingLink />
//             <Button 
//               variant="contained" 
//               onClick={() => setOpenTemplateDialog(true)}
//               style={{ width: 'fit-content' }}
//             >
//               Change Bill Template
//             </Button>
//             {/* Other existing buttons can stay here */}
//           </Box>
//         )}
//       </DashboardCard2>

//       {/* Bill Template Selection Dialog */}
//       <Dialog
//         open={openTemplateDialog}
//         onClose={() => setOpenTemplateDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>Select Bill Template</DialogTitle>
//         <DialogContent>
//           <Typography variant="body1" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
//             Current selected template: <span style={{ color: '#6174DD' }}>{templates.find(t => t.id === selectedTemplate)?.name}</span>
//           </Typography>

//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             {templates.map((template) => (
//               <Grid item xs={12} md={4} key={template.id}>
//                 <Box
//                   sx={{
//                     border: selectedTemplate === template.id
//                       ? '2px solid #6174DD'
//                       : '1px solid #e0e0e0',
//                     borderRadius: '8px',
//                     p: 2,
//                     cursor: 'pointer',
//                     transition: 'all 0.3s ease',
//                     backgroundColor: selectedTemplate === template.id
//                       ? '#f5f7ff'
//                       : '#ffffff',
//                     '&:hover': {
//                       transform: 'translateY(-5px)',
//                       boxShadow: '0 6px 12px rgba(0,0,0,0.1)',
//                       borderColor: '#6174DD'
//                     }
//                   }}
//                   onClick={() => handleTemplateSelect(template.id)}
//                 >
//                   <Box
//                     sx={{
//                       position: 'relative',
//                       width: '100%',
//                       height: '200px',
//                       overflow: 'hidden',
//                       borderRadius: '4px',
//                       mb: 2
//                     }}
//                   >
//                     <img
//                       src={template.image}
//                       alt={template.name}
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'contain',
//                         objectPosition: 'center'
//                       }}
//                     />
//                   </Box>
//                   <Typography
//                     variant="h6"
//                     align="center"
//                     sx={{
//                       mt: 1,
//                       fontWeight: 'medium',
//                       color: selectedTemplate === template.id
//                         ? '#6174DD'
//                         : 'text.primary'
//                     }}
//                   >
//                     {template.name}
//                   </Typography>
//                   {selectedTemplate === template.id && (
//                     <Box
//                       sx={{
//                         mt: 1,
//                         textAlign: 'center',
//                         color: '#6174DD',
//                         fontWeight: 'bold',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center'
//                       }}
//                     >
//                       <span style={{
//                         display: 'inline-block',
//                         width: '8px',
//                         height: '8px',
//                         borderRadius: '50%',
//                         backgroundColor: '#6174DD',
//                         marginRight: '8px'
//                       }}></span>
//                       Selected
//                     </Box>
//                   )}
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ p: 3 }}>
//           <Button
//             onClick={() => setOpenTemplateDialog(false)}
//             variant="outlined"
//             sx={{
//               color: '#6174DD',
//               borderColor: '#6174DD',
//               '&:hover': {
//                 backgroundColor: '#f5f7ff',
//                 borderColor: '#6174DD'
//               }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleUpdateTemplate}
//             variant="contained"
//             disabled={loading}
//             sx={{
//               backgroundColor: '#6174DD',
//               '&:hover': {
//                 backgroundColor: '#4a5bb5'
//               }
//             }}
//           >
//             {loading ? 'Saving...' : 'Save Template'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={!!notification}
//         autoHideDuration={6000}
//         onClose={() => setNotification('')}
//       >
//         <Alert onClose={() => setNotification('')} severity="success" sx={{ width: '100%',marginLeft:'20rem' }}>
//           {notification}
//         </Alert>
//       </Snackbar>
//     </PageContainer>
//   );
// };

// export default Settings;